import React from "react";
import Entity from "../../components/Entity";
import { PROVINCES } from "../../Constants";

function Territory() {
  return (
    <Entity
      title={(e) => e.name || "New Territory"}
      formShema={{
        fields: [
          { name: "Name",     propertyName: "name",     type: "input",  col: 6 },
          { name: "Province", propertyName: "province", type: "select", options: PROVINCES, col: 6 },
        ],
      }}
    />
  );
}

export default Territory;
